import React from 'react';
import {
  Body,
  IneligibleAccountDetailsWrapper,
  Title,
  HyperLink,
} from './IneligibleAccountDetails.styles';
import DocWarningIcon from '../../../../../assets/doc-warning-icon';

const IneligibleAccountDetails = ({ title }: any) => (
  <IneligibleAccountDetailsWrapper>
    <DocWarningIcon />
    <Title>{title}</Title>
    <Body>
      <p>Please contact Bridgecrest for more information: </p>
      <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>
    </Body>
  </IneligibleAccountDetailsWrapper>
);

export default IneligibleAccountDetails;
